<flx-flex-container alignItems="center">
	<flx-heading size="medium" align="center" type="creation" weight="extra-light">Select Voucher Type</flx-heading>

	<div class="voucher-types-container">
		<div class="voucher-main-content">
			<!-- Search Bar -->
			<div class="voucher-search-bar">
				<div class="voucher-search-section">
					<div class="voucher-search-row">
						<input
							type="text"
							class="voucher-search-input"
							[class.search-selected]="isListCollapsed() && hasSelectedVoucher()"
							[placeholder]="showSearchPlaceholder() ? 'Enter SKU, article number or description' : ''"
							[ngModel]="searchTerm()"
							(ngModelChange)="onSearchInput($event)"
							(click)="onSearchBarClick()"
							(focus)="onSearchBarClick()"
						/>
						<button class="voucher-search-btn" (click)="onSearchIconClick()" [title]="isListCollapsed() ? 'Show voucher types' : 'Search'">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<circle cx="11" cy="11" r="8"></circle>
								<path d="m21 21-4.3-4.3"></path>
							</svg>
						</button>
					</div>
					<!-- Voucher Table -->
					@if (!isListCollapsed()) {
						<div class="voucher-table-container">
					<table class="voucher-table">
						<tbody>
							@for (voucher of filteredVoucherTypes(); track voucher.id) {
								<tr
									class="voucher-row"
									[class.selected]="isSelected(voucher)"
									(click)="selectVoucher(voucher)"
								>
									<td class="voucher-name">{{ voucher.name }}</td>
									<td class="voucher-article">MID: Article -{{ voucher.product_template.mid }}</td>
									<td class="voucher-sku">SKU: {{ voucher.product_template.sku }}</td>
									<td class="voucher-price">{{ formatPrice(voucher.product_template.price) }}</td>
								</tr>
							}
						</tbody>
					</table>
					@if (isEmptyResults()) {
							<div class="voucher-no-results">
								No voucher types found
							</div>
						}
						</div>
					}
				</div>
				<!-- <button class="voucher-add-btn" (click)="onAddVoucher()" [disabled]="!hasSelectedVoucher()">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<path d="M5 12h14"></path>
						<path d="M12 5v14"></path>
					</svg>
				</button> -->
			</div>
		</div>

		<!-- Form Below -->
		@if (hasSelectedVoucher()) {
			<div>
				<form [formGroup]="bf.bigForm">
					<div formArrayName="jobs" >
						<div [formGroupName]="0" class="voucher-details-form">
							@for (field of visibleVoucherFields(); track field.controlName) {
								<div class="form-field">
									@switch (field.type) {
										@case ('checkbox') {
											<flx-checkbox
												[formControlName]="field.controlName"
												[checked]="jobGroup()?.get(field.controlName)?.value"
												(checkChanged)="jobGroup()?.get(field.controlName)?.setValue($event)"
											>
												{{ field.label }}
											</flx-checkbox>
										}
										@case ('dropdown') {
											<flx-label>{{ field.label }}</flx-label>
											<flx-dropdown
												[formControlName]="field.controlName"
												[displayOptions]="{ displayKey: field.displayKey ?? 'display', valueKey: field.valueKey ?? 'value' }"
												[itemsOption]="field.optionsSource === 'stores' ? stores() : []"
												[searchEnabled]="true"
												[placeHolder]="field.placeholder ?? ''"
											></flx-dropdown>
										}
									@default {
										<flx-label>{{ field.label }}</flx-label>
										<flx-input-text
											[type]="field.type === 'number' ? 'number' : 'text'"
											[formControlName]="field.controlName"
											size="normal"
											(blur)="onFieldBlur(field)"
											(keydown)="onFieldKeydown($event, field)"
										></flx-input-text>
									}
									}
								</div>
							}
						</div>
					</div>
				</form>
			</div>
		}
	</div>
</flx-flex-container>
